import MyULoader from '@/shared/ui/MyULoader';
import { cn } from '@/shared/lib/cn';

interface SpinnerProps {
  /** Stretch to cover the full viewport (used by the route-level Suspense fallback). */
  fullScreen?: boolean;
  className?: string;
  /** Optional override label. Defaults to "Loading…". */
  label?: string | null;
  /** Compact in-flow variant (no backdrop, smaller logo). */
  inline?: boolean;
}

/**
 * @deprecated Prefer importing `MyULoader` from `@/shared/ui/MyULoader`
 * directly. This component is kept as a thin pass-through so existing imports
 * (`App.tsx`, feature views, modals) continue to work and automatically get
 * the branded MyU loader.
 */
export default function Spinner({ fullScreen, className, label, inline }: SpinnerProps) {
  if (inline) {
    return <MyULoader inline label={label ?? 'Loading…'} className={className} />;
  }

  // Wrap the loader in a viewport-sized div for the legacy `fullScreen` use
  // case (top-level Suspense fallback) so it covers the screen even without a
  // positioned ancestor. For in-page placements we just fill the parent.
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        fullScreen ? 'fixed inset-0 z-50 bg-white' : 'h-full w-full',
        className,
      )}
    >
      <MyULoader label={label ?? 'Loading…'} />
    </div>
  );
}
